import styled from "styled-components";

export const MainLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  width: 100%;
`;

export const ContentContainer = styled.div`
  flex: 1;
  overflow: auto;
`; 